import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type"];
import React from "react";
import PrimitiveSkeletonBox from "../primitives";
import { jsx as _jsx } from "react/jsx-runtime";
function InputSkeleton(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "default" : _ref$type,
    boxProps = _objectWithoutProperties(_ref, _excluded);
  var height = type === "textarea" ? 95.99 : 32;

  // let boxProps override width but not override height
  return /*#__PURE__*/_jsx(PrimitiveSkeletonBox, _extends({
    width: "100%"
  }, boxProps, {
    height: height
  }));
}
export default InputSkeleton;